import { render, staticRenderFns } from "./API_Key.vue?vue&type=template&id=004b71b2&scoped=true"
import script from "./API_Key.vue?vue&type=script&lang=js"
export * from "./API_Key.vue?vue&type=script&lang=js"
import style0 from "./API_Key.vue?vue&type=style&index=0&id=004b71b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004b71b2",
  null
  
)

export default component.exports